import { utcToZonedTime as m, format as r } from "date-fns-tz";
const s = ({
  timestamp: t,
  formatMethod: o
}) => {
  const n = new Date(t), e = Intl.DateTimeFormat().resolvedOptions().timeZone, a = m(n, e);
  return r(a, o, { timeZone: e });
};
export {
  s as default
};
//# sourceMappingURL=date.js.map
